import React, { useEffect, useState } from "react";
import SelectByModel from "../../../../../common/selectByModel";
import { extractVariables } from "../../../../../../services/commonService";

const emptySkillModel = {
  ModelId: "default",
  ModelName: "",
  CurlRequestString: "",
  UserAssistantMessageFormat: "",
  DynamicProperties: []
};

const SkillLLMModels = ({
  skillStoreForm,
  updateSkillStoreForm,
  modelErrors,
  models,
  setModeErrors
}) => {
  const skillModels = skillStoreForm?.SkillModels || [];
  const [errors, setErrors] = useState([]);

  const safeModelErrors = Array.isArray(modelErrors)
    ? modelErrors
    : [];

  useEffect(() => {
    setErrors(safeModelErrors);
  }, [safeModelErrors]);

  const addModel = () => {
    updateSkillStoreForm("SkillModels", [
      ...skillModels,
      { ...emptySkillModel }
    ]);
  };

  const removeModel = (index) => {
    updateSkillStoreForm(
      "SkillModels",
      skillModels.filter((_, i) => i !== index)
    );
  };

  const updateModelField = (index, field, value) => {
    const updatedModels = [...skillModels];
    const currentModel = updatedModels[index];

    const updatedModel = {
      ...currentModel,
      [field]: value
    };

    if (field === "CurlRequestString") {
      const extractedVariables = extractVariables(value);
      const existingMap =
        (currentModel.DynamicProperties || []).reduce((map, prop) => {
          map[prop.key] = prop.Value;
          return map;
        }, {});

      updatedModel.DynamicProperties = extractedVariables.map((v) => ({
        key: v.key,
        Value: existingMap[v.key] || ""
      }));
    }

    updatedModels[index] = updatedModel;

    if (modelErrors?.[index]?.[field]) {
      const updatedErrors = [...modelErrors];
      updatedErrors[index] = {
        ...updatedErrors[index],
        [field]: ""
      };
      setModeErrors(updatedErrors);
    }
    updateSkillStoreForm("SkillModels", updatedModels);
  };


  const addDynamicProperty = (modelIndex) => {
    const updated = [...skillModels];
    updated[modelIndex].DynamicProperties = [
      ...(updated[modelIndex].DynamicProperties || []),
      { key: "", Value: "" }
    ];
    updateSkillStoreForm("SkillModels", updated);
  };

  const updateDynamicProperty = (
    modelIndex,
    propIndex,
    field,
    value
  ) => {
    const updated = [...skillModels];
    updated[modelIndex].DynamicProperties[propIndex] = {
      ...updated[modelIndex].DynamicProperties[propIndex],
      [field]: value
    };

    if (
      modelErrors?.[modelIndex]?.DynamicProperties?.[propIndex]?.[field]
    ) {
      const updatedErrors = [...modelErrors];

      updatedErrors[modelIndex].DynamicProperties[propIndex] = {
        ...updatedErrors[modelIndex].DynamicProperties[propIndex],
        [field]: ""
      };

      setErrors(updatedErrors);
    }

    updateSkillStoreForm("SkillModels", updated);
  };

  const removeDynamicProperty = (modelIndex, propIndex) => {
    const updated = [...skillModels];
    updated[modelIndex].DynamicProperties =
      updated[modelIndex].DynamicProperties.filter(
        (_, i) => i !== propIndex
      );
    updateSkillStoreForm("SkillModels", updated);
  };

  const onSelectedModel = (selectedValue, field, index) => {
    const updatedModels = [...skillModels];
    const currentModel = updatedModels[index];

    const updatedModel = {
      ...currentModel,
      [field]: selectedValue
    };

    if (modelErrors?.[index]?.[field]) {
      const updatedErrors = [...modelErrors];
      updatedErrors[index] = {
        ...updatedErrors[index],
        [field]: ""
      };
      setModeErrors(updatedErrors);
    }
    updatedModels[index] = updatedModel;
    updateSkillStoreForm("SkillModels", updatedModels);
  }

  return (
    <>
      <div className="resource-add">
        <h2 className="h2">LLM Models</h2>
        <button title="Add Model" onClick={addModel} className="plus-icon-white-bot" />
      </div>

      {skillModels.map((item, index) => (
        <div key={index} className="model-card">

          <h5>Model {index + 1}</h5>

          <div className="form-group margin-model">
            {/* Model Dropdown */}
            <div className="form-config-box" >
              <SelectByModel
                modelsData={models}
                selectedModel={item.ModelId}
                onSelectedModel={onSelectedModel}
                index={index}
                modelErrors={modelErrors}
                setModeErrors={setModeErrors}>
              </SelectByModel>
            </div>
            <div className="form-config-box">
              <button className="" title="Remove Model" onClick={() => removeModel(index)}>
                <div className="minus-icon-white"></div>
              </button>
            </div>
            <div className="form-config-box">

            </div>
          </div>
          <div className="form-group margin-model">
            <div className="form-config-box">
              <div className="input-wrapper">
                <label>Curl Request<span className="red">*</span>{" "}</label>
                <textarea
                  className={`prompt-text ${modelErrors?.[index]?.CurlRequestString ? "border-red" : ""
                    }`}
                  placeholder="Enter Curl request"
                  value={item.CurlRequestString || ""}
                  onChange={(e) =>
                    updateModelField(
                      index,
                      "CurlRequestString",
                      e.target.value
                    )
                  }
                  rows={4}
                />
                {modelErrors?.[index]?.CurlRequestString && (
                  <span className="error-text">
                    {modelErrors[index].CurlRequestString}
                  </span>
                )}
              </div>
            </div>
            <div className="form-config-box ">
              {/* Assistant Message Format */}
              <div className="input-wrapper">
                <label>Assistant Message Format<span className="red">*</span>{" "}</label>
                <textarea
                  className={`prompt-text ${modelErrors?.[index]?.UserAssistantMessageFormat
                    ? "border-red"
                    : ""
                    }`}
                  placeholder="Assistant message format"
                  value={item.UserAssistantMessageFormat || ""}
                  onChange={(e) =>
                    updateModelField(
                      index,
                      "UserAssistantMessageFormat",
                      e.target.value
                    )
                  }
                  rows={4}
                />
                {modelErrors?.[index]?.UserAssistantMessageFormat && (
                  <span className="error-text">
                    {modelErrors[index].UserAssistantMessageFormat}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className=" margin-model">
            <div className="dynamic-section">
              {item.DynamicProperties?.length > 0 && (
                <div className="all-variavle-inputs">
                  {
                    item.DynamicProperties?.map((prop, pIndex) => (
                      <div key={pIndex} className="variable-input">
                        <div className="input-wrapper">
                          <input
                            className={
                              modelErrors?.[index]?.DynamicProperties?.[pIndex]?.key
                                ? "error-border"
                                : ""
                            }
                            type="text"
                            placeholder="Key"
                            value={prop.key}
                            onChange={(e) =>
                              updateDynamicProperty(
                                index,
                                pIndex,
                                "key",
                                e.target.value
                              )
                            }
                          />
                          {modelErrors?.[index]?.DynamicProperties?.[pIndex]?.key && (
                            <span className="error-text">
                              {modelErrors[index].DynamicProperties[pIndex].key}
                            </span>
                          )}
                        </div>
                        <div className="input-wrapper">
                          <input
                            type="text"
                            className={
                              modelErrors?.[index]?.DynamicProperties?.[pIndex]?.Value
                                ? "error-border"
                                : ""
                            }
                            placeholder="Value"
                            value={prop.Value}
                            onChange={(e) =>
                              updateDynamicProperty(
                                index,
                                pIndex,
                                "Value",
                                e.target.value
                              )
                            }
                          />
                          {modelErrors?.[index]?.DynamicProperties?.[pIndex]?.Value && (
                            <span className="error-text">
                              {modelErrors[index].DynamicProperties[pIndex].Value}
                            </span>
                          )}
                        </div>
                        <div className="button-wrap-row">
                          <button title="Remove" onClick={() => removeDynamicProperty(index, pIndex)}>
                            <div className="minus-icon-white"></div>
                          </button>
                          {pIndex === item.DynamicProperties?.length - 1 && (
                            <button title="Add" onClick={() => addDynamicProperty(index)}>
                              <div className="plus-icon-white-bot"></div>
                            </button>
                          )}
                        </div>
                      </div>
                    ))
                  }
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default SkillLLMModels;
